<main class="menu" id="checkout">
    <div id="background"></div>
    <header>
        <header-component></header-component>
        <div class="nav">
            <h1>{{_('checkout')}}</h1>
            <span class="icon back" @click="app.page = 'Menu'">
                chevron_left
            </span>
        </div>
    </header>
    <section v-if="app.house.facade_image" class="image-container">
        <img :src="app.house.facade_image" />
    </section>
    <hr />

    <section v-if="app.checkedout" class="checkout-description">
        <h2>{{_('checkout_done')}}</h2>
        <p>{{_('thanks_checkout', firstGuestName(), _(app.house.name) )}}</p>
        <hr />
    </section>
    <section
        v-else-if="!Object.keys(uploaded).length"
        class="checkout-description"
    >
        <h2>{{_('checkout_guide')}}</h2>
        <p>{{_('checkout_description')}}</p>
        <hr />
    </section>
    <template v-else>
        <section class="checkout-description">
            <h2>{{_('checkout_guide')}}</h2>
            <p>{{_('checkout_picture_guide')}}</p>
            <hr />
        </section>

        <section v-for="(already, id) in uploaded">
            <h4>{{ _('honor', guestNameFrom(id)) }}</h4>
            <div class="image-container">
                <img v-if="pictures[id]" :src="pictures[id]" />
                <div v-else class="icon">person</div>
                <div v-if="already" class="message">{{_('uploaded')}}</div>
            </div>
            <div class="flex-buttons">
                <button
                    @click="uploadImage(id)"
                    class="skeleton"
                    before-icon="camera_alt"
                >
                    {{_('select_file')}}
                </button>
            </div>
            <hr />
        </section>
    </template>

    <section class="flex-buttons">
        <button v-if="checkoutable()" @click="checkout()">
            {{_('checkout')}}
        </button>
        <button
            v-if="app.checkedout"
            class="skeleton"
            @click="app.setPage('Menu')"
        >
            {{_('close')}}
        </button>
    </section>
</main>
